export var OwnerFlow;
(function (OwnerFlow) {
    OwnerFlow["OpenCell"] = "openCell";
    OwnerFlow["CodeForCourier"] = "codeForCourier";
})(OwnerFlow || (OwnerFlow = {}));
